//============================================================================
// Name        : asset_details.ts
// Purpose     : Implement logic for the asset details page
// Created     : 2020-03-16
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import {InitPage} from "../index";

interface INoteData {
    noteDate: string;
    content: string;
    username: string;
}

class AssetDetails {
    init() {
        $("#new_note_content").on("keyup", this.checkNoteContent);
        $("#save-note").on("click", this.saveNote);
        $("#new_note_content").on("keydown", (e) => {
            if (e.keyCode == 13) {
                this.saveNote();
            }
        });
    }

    checkNoteContent() {
        const newNoteContent = $("#new_note_content").val().toString().trim();
        if (newNoteContent.length == 0) {
            $("#save-note").prop("disabled", "disabled");
            $("#save-note").addClass('disabled');
        }
        else {
            $("#save-note").prop("disabled", "");
            $("#save-note").removeClass('disabled');
        }
    }

    saveNote = async () => {
        const newNoteContent = $("#new_note_content").val().toString().trim();
        const resp = await axios.post($("input[name='save_note_url']").val().toString(), {
            new_note_content:   newNoteContent,
            authenticity_token: $("input[name='authenticity_token']").val(),
            redirect_url:       $("input[name='redirect_url']").val()
        });
        if (resp.status != 200) {
            window.showErrorDialog("Error saving note, please try again later.");
            return;
        }
        else
        {
            $("#save-note").addClass('disabled');
            $("#save-note").prop("disabled", "disabled");
            $("#new_note_content").attr('readonly','readonly');
        }

        // If we saved the note correctly update it on the UI
        const newNote = resp.data as INoteData;
        const tr = `
            <tr>
                <td class="note-date">${newNote.noteDate}</td>
                <td>${newNote.content}</td>
                <td class="note-user">${newNote.username}</td>
            </tr>`;
        $(".notes-tbody").prepend(tr);
        $("#new_note_content").val("");
    }
}

export function LoadPage() {
    InitPage("items item_details", () => {
        const assetDetails = new AssetDetails();
        assetDetails.init();
    });
}
